export default __webpack_public_path__ + "static/hovenier-a7827454df28ac2ce7ef97ff7705c1f3.jpg";